module.exports = __webpack_public_path__ + "static/media/C4.e5f7078b.jpg";